import * as React from 'react';
import { styled } from '@mui/material/styles';
import Badge from '@mui/material/Badge';
import Avatar, { AvatarProps } from '@mui/material/Avatar';

import { BadgeOrigin } from '@mui/material';

const PrimaryAvatar = styled(Avatar)(({ theme }) => ({
  width: 28,
  height: 28,
  backgroundColor: theme.palette.classicPrimary.main
}));

const OutlinedAvatar = styled(Avatar)(({ theme }) => ({
  borderColor: theme.palette.background.paper,
  borderStyle: 'solid',
  borderWidth: '1px'
}));

export interface BadgedAvatarProps {
  badgeContent?: React.ReactNode;
  badgeBackgroundColor?: string;
  badgeSize?: 'small' | 'large';
  anchorOrigin?: BadgeOrigin;
}

const badgeSizes = {
  small: '13px',
  large: '18px'
};
const badgeBorderWidths = {
  small: '1px',
  large: '2px'
};

export const BadgedAvatar = (props: AvatarProps & BadgedAvatarProps) => {
  const { badgeContent, badgeBackgroundColor, badgeSize, anchorOrigin, ...avatarProps } = props;

  return (
    <>
      {badgeContent ? (
        <Badge
          overlap="circular"
          anchorOrigin={anchorOrigin}
          badgeContent={
            <OutlinedAvatar
              sx={{
                width: badgeSizes[badgeSize ?? 'small'],
                height: badgeSizes[badgeSize ?? 'small'],
                borderWidth: badgeBorderWidths[badgeSize ?? 'small'],
                backgroundColor: badgeBackgroundColor
              }}
            >
              {badgeContent}
            </OutlinedAvatar>
          }
        >
          <PrimaryAvatar {...avatarProps} />
        </Badge>
      ) : (
        <PrimaryAvatar {...avatarProps} />
      )}
    </>
  );
};
